import { getUserID } from "../Utility/service";
import {HUBSPOT_KEY_SLUG, HUBSPOT_USER_BASED_KEY_SLUG } from "../constants/Api_constants";
import { axiosSecureInstance } from "./axios";
const userId = getUserID();

export const storeHubspotKeyToDB = async (HubSpotKey)=>{
    const body = {
        userId : userId,
        HubspotKey : HubSpotKey
    }
    const responseOfFireCrawlKeyStore = await axiosSecureInstance.post(HUBSPOT_KEY_SLUG,body);
    return responseOfFireCrawlKeyStore;
};

export const deleteHubspotAccessKeyFromDB = async ()=>{
    const responseOfFireCrawlKeyDelete = await axiosSecureInstance.delete(HUBSPOT_USER_BASED_KEY_SLUG(userId));
    return responseOfFireCrawlKeyDelete;
};

export const getHubspotCredentials = async (setIsHubspotConnected)=>{
    const hubspotCredential =userId? await axiosSecureInstance.get(HUBSPOT_USER_BASED_KEY_SLUG(userId)):null;
    if(hubspotCredential?.data?.getHubspotCredential?.accessToken){
        setIsHubspotConnected(true);
    }else{
        setIsHubspotConnected(false);
    }
    return hubspotCredential
};